import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { memo, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { IAlertDetail } from '~/utils/interface/alert';
import { cast } from '~/utils/helper';

export type ProcessedStatusProps = {
  data: IAlertDetail;
};

const Row = ({ label, value }: { label: string; value: ReactNode }) => (
  <Box className='flex w-full flex-row items-start gap-5'>
    <Box className='flex h-5 w-[140px] shrink-0 items-center overflow-hidden opacity-100'>
      <Typography component='span' className='truncate text-sm leading-[140%] text-[#7B8794] font-["Manrope",sans-serif]'>
        {label}
      </Typography>
    </Box>
    <Box className='min-w-0 flex-1 text-left text-[14px] font-normal leading-[140%] tracking-[0.02em] text-[#161A1F] font-["Manrope",sans-serif] break-words'>
      {value}
    </Box>
  </Box>
);

const ProcessedStatus = (props: ProcessedStatusProps) => {
  const { data } = props;
  const { t } = useTranslation('admin/alert');

  const formatResolvedAt = (value?: string | null) => {
    if (!value) return '—';
    return dayjs(value).format('HH:mm:ss DD/MM/YYYY');
  };

  const display = (value?: string | null) => {
    const v = cast(value);
    return v === '' || v === undefined ? '—' : v;
  };

  return (
    <Box className='flex w-full flex-col gap-3'>
      <Row label={t('alertDetail.resolver')} value={display(data.resolved_by)} />
      <Row
        label={t('alertDetail.statusField')}
        value={
          <Typography component='span' className='text-[14px] font-medium leading-[140%] tracking-[0.02em] text-green-600'>
            {t('alertDetail.processedState')}
          </Typography>
        }
      />
      <Row label={t('alertDetail.resolvedAt')} value={formatResolvedAt(data.resolved_at)} />
      <Row label={t('alertDetail.noteField')} value={display(data.note)} />
    </Box>
  );
};

export default memo(ProcessedStatus);
